export default __webpack_public_path__ + "static/summer_containers96-b05be0117d297ea5628660c8bb84c261.webp";